import { render, staticRenderFns } from "./InternalChatView.vue?vue&type=template&id=0f30e794&scoped=true&"
import script from "./InternalChatView.vue?vue&type=script&lang=js&"
export * from "./InternalChatView.vue?vue&type=script&lang=js&"
import style0 from "./InternalChatView.vue?vue&type=style&index=0&id=0f30e794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f30e794",
  null
  
)

export default component.exports